module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-02-16 at 21.42.52 (2) - Copy.899336a6.jpeg";